<div class="displays-list">
  <div class="displays-list__item mb-6" *ngFor="let display of displays()">
    <app-displays-list-item [display]="display"></app-displays-list-item>
  </div>
  <div *ngIf="loaded() && displays() && displays().length == 0" class="empty-container flex justify-center">
    <div class="empty-title typography-title-l">{{ 'my_sales.no_hay_resultados_newclients' | translate }}</div>
    <div>
        <div class="empty-button">
        </div>
    </div>
</div>
</div>
